<template>
  <footer class="main-container" role="contentinfo">
    <div class="row">
      <div class="col footer-logo" :class="footerLogoAlignment">
        <img
          :src="footer.logo"
          :alt="footer.alt"
          v-if="footer.logo"
          :style="{ height: `${footer.footerLogoSize}px` }"
        />
      </div>
      <div class="col-lg-auto social-icons" v-if="hasSocial">
        <a v-for="item in socials" :key="item.name" :href="item.url" target="_blank"
          ><SocialMediaIcons :name="item.name" /><span class="visually-hidden">opens in new window</span></a
        >
      </div>
    </div>
    <div class="row pt-0">
      <div v-html="footer.disclaimer" class="disclaimer-content" v-if="footer.disclaimer"></div>
      <div v-html="footer.disclaimerLinks" class="disclaimer-link" v-if="footer.disclaimerLinks"></div>
    </div>
  </footer>
</template>
<script>
import SocialMediaIcons from "../atoms/socialMediaIcons.vue";
export default {
  name: "Footer",
  props: {
    footer: Object,
    socials: Array,
  },
  components: { SocialMediaIcons },
  computed: {
    hasSocial() {
      return this.socials.length > 0;
    },

    footerLogoAlignment() {
      let alignment = "";
      switch (this.footer.footerLogoAlignment.toLowerCase()) {
        case "center":
          alignment = "justify-content-center";
          break;
        case "right":
          alignment = "justify-content-end";
          break;
      }
      return alignment;
    },
  },
};
</script>
<style lang="scss" scoped>
footer.main-container {
  padding: 0 40px;
  color: var(--primaryText);

  @include media-breakpoint-down(md) {
    padding: 0 30px;
  }
}

.footer-logo {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0px;
  // width: 100%;

  img {
    min-height: 10px;
    max-height: 70px;

    @include media-breakpoint-down(md) {
      // height: unset !important;
      // min-height: unset !important;
      // max-height: unset !important;
      // width: 100% !important;
    }
  }

  h5 {
    font-size: 32px;
    line-height: 150%;
    font-weight: 400;
  }

  &.logo-center {
    justify-content: center;
  }

  &.logo-right {
    justify-content: flex-end;
  }
}

.disclaimer-content {
  font-size: 15px;
  line-height: 150%;
  padding: 0;

  ::v-deep * {
    font-family: var(--micrositeTypeStyle) !important;
  }
}

.disclaimer-link {
  margin-top: 10px;
  font-size: 15px;
  line-height: 150%;
  padding-left: 0 !important;

  ::v-deep * {
    font-family: var(--micrositeTypeStyle) !important;
  }
}

.social-icons {
  justify-content: flex-start;
  display: flex;
  column-gap: 24px;
  padding: 24px 0 0 0;

  @include media-breakpoint-up(lg) {
    justify-content: flex-end;
    padding: 0px 0px 0px 24px;
  }
}
</style>
